var smsMap = {
  id: 'id',
  log: 'log',
  transportMethod: 'transportMethod',
  transportSMSId: 'transportSMSId',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default smsMap;